export enum OrderStatus {
  NEW = "NEW",
  STARTED = "STARTED",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  UNPROCESSABLE = "UNPROCESSABLE",
  CANCELLED = "CANCELLED",
  PARTIALLY_PROCESSED = "PARTIALLY_PROCESSED",
  REFUNDED = "REFUNDED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",

  //Sale
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
  ARCHIVED = "ARCHIVED",
}

export enum OrderFulfillmentStatus {
  DROPSHIP = "Dropship",
  PENDING = "Pending",
  PARTIALLY_PICKED = "Partially picked",
  PICKED = "Picked",
  SHIPPED = "Shipped",
  CANCELED = "Canceled",
  ARCHIVED = "Archived",
}

export const OrderStatusConverter = {
  NEW: "New",
  STARTED: "Started",
  ERROR: "Error",
  SUCCESS: "Success",
  UNPROCESSABLE: "Unprocessable",
  CANCELLED: "Canceled",
  PARTIALLY_PROCESSED: "Partially Processed",

  //Sale
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  FINISHED: "Finished",
  ARCHIVED: "Archived",
  REFUNDED: "Refunded",
  PARTIALLY_REFUNDED: "Partially Refunded",
};

export enum OrderItemProcessStatus {
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  PARTIALLY_PICKED = "PARTIALLY_PICKED",
  PICKED = "PICKED",
  PICKING = "PICKING",
  PENDING = "PENDING",
  SHIPPED = "SHIPPED",
  CANCELLED = "CANCELLED",
  CANCELED = "CANCELED",

  //ERRORS
  NEW = "NEW",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export const OrderItemProcessStatusConverter = {
  CANCELLED: "Canceled",
  CANCELED: "Canceled",
  REFUNDED: "Refunded",
  PARTIALLY_REFUNDED: "Partially Refunded",
  PARTIALLY_PICKED: "Partially picked",
  PICKED: "Picked",
  PICKING: "Picking",
  PENDING: "Pending",
  SHIPPED: "Shipped",

  //ERRORS
  NEW: "New",
  ERROR: "Error",
  SUCCESS: "Success",
};

export enum PickingItemStatus {
  PARTIALLY_PICKED = "PARTIALLY_PICKED",
  PICKED = "PICKED",
  PICKING = "PICKING",
  PENDING = "PENDING",
  SHIPPED = "SHIPPED",
  CANCELED = "CANCELED",
}

export const PickingItemStatusConverter = {
  CANCELLED: "Canceled",
  CANCELED: "Canceled",
  REFUNDED: "Refunded",
  PARTIALLY_REFUNDED: "Partially Refunded",
  PARTIALLY_PICKED: "Partially picked",
  PICKED: "Picked",
  PICKING: "Picking",
  PENDING: "Pending",
  SHIPPED: "Shipped",
};

export const filterStatusOptions = [
  { id: "1", value: OrderStatus.SUCCESS, label: "Success" },
  { id: "2", value: OrderStatus.ERROR, label: "Error" },
  { id: "3", value: OrderStatus.UNPROCESSABLE, label: "Unprocessable" },
  {
    id: "4",
    value: OrderStatus.PARTIALLY_PROCESSED,
    label: "Partially Processed",
  },
  { id: "5", value: OrderStatus.CANCELLED, label: "Canceled" },
  { id: "6", value: OrderStatus.REFUNDED, label: "Refunded" },
  {
    id: "7",
    value: OrderStatus.PARTIALLY_REFUNDED,
    label: "Partially Refunded",
  },
];

export const filterFulfillmentStatusOptions = [
  {
    id: "1",
    value: OrderFulfillmentStatus.DROPSHIP,
    label: OrderFulfillmentStatus.DROPSHIP,
  },
  {
    id: "2",
    value: OrderFulfillmentStatus.PENDING,
    label: OrderFulfillmentStatus.PENDING,
  },
  {
    id: "3",
    value: OrderFulfillmentStatus.PARTIALLY_PICKED,
    label: OrderFulfillmentStatus.PARTIALLY_PICKED,
  },
  {
    id: "4",
    value: OrderFulfillmentStatus.PICKED,
    label: OrderFulfillmentStatus.PICKED,
  },
  {
    id: "5",
    value: OrderFulfillmentStatus.SHIPPED,
    label: OrderFulfillmentStatus.SHIPPED,
  },
  {
    id: "6",
    value: OrderFulfillmentStatus.CANCELED,
    label: OrderFulfillmentStatus.CANCELED,
  },
  {
    id: "7",
    value: OrderFulfillmentStatus.ARCHIVED,
    label: OrderFulfillmentStatus.ARCHIVED,
  },
];

export const defaultOrderProcessStatusFilters = filterStatusOptions.map(
  (option) => option.value,
);

const orderStatusValues = new Set<string>(Object.values(OrderStatus));
const orderFulfillmentStatusValues = new Set<string>(
  Object.values(OrderFulfillmentStatus),
);

export const isOrderStatus = (value: string): value is OrderStatus =>
  orderStatusValues.has(value);

export const isOrderFulfillmentStatus = (
  value: string,
): value is OrderFulfillmentStatus => orderFulfillmentStatusValues.has(value);
